import React, { useEffect, useState } from 'react'

import { TabContent, TabPane } from 'reactstrap'
import WizardInnerLeftMenu from './WizardInnerLeftMenu';
import WizardMenu from './WizardMenu';

const WizardTopMenuContent = (props) => {
    const { dynamicTabs, activeTab, handleActiceSubTab } = { ...props }
    console.log("PROPS",props)
    const MenuItems = WizardMenu();
    const [tabs, setTabs] = useState([])
    const [component, setComponent] = useState({})

    useEffect(() => {
        setTabs(dynamicTabs);
        const activeComponent = MenuItems.filter((tab, key) => {
            return tab.right === true
        })[0];
        setComponent(activeComponent)
    }, [activeTab])
    return (
        <div>
            {tabs.length > 0 ? (
                <TabContent activeTab={activeTab}>
                    {
                        tabs
                        && tabs.map((item) => {
                            return (
                                <TabPane tabId={item.key}>
                                    <div className="h-100">
                                        <div className="h-100">
                                            <WizardInnerLeftMenu subCategKey={item.key} handleActiceSubTab={handleActiceSubTab}/>
                                        </div>
                                    </div>
                                </TabPane>
                            )
                        })}
                </TabContent>
            ) : (
                <TabContent activeTab={component.key}>
                    <React.Fragment key={component.key}>
                        <TabPane tabId={component.key}>
                            <div className="h-100">
                                <div className="h-100">
                                    <WizardInnerLeftMenu subCategKey={component.key} handleActiceSubTab={handleActiceSubTab}/>
                                </div>
                            </div>
                        </TabPane>
                    </React.Fragment>
                </TabContent>
            )}
        </div>
    )
}

export default WizardTopMenuContent
